import type { ToolbarTheme } from '../types';

export const darkTheme: ToolbarTheme = {
  background: '#1c1e21',
  color: '#ebedf0',
  overlay: 'rgba(255, 255, 255, .15)',
  size: 30,
};

export const lightTheme: ToolbarTheme = {
  background: '#ebedf0',
  color: '#1c1e21',
  overlay: 'rgba(55,99,115, .1)',
  size: 30,
};
